import React from "react";

import { ROUTES } from "../../data/content";
import PageMeta from "./PageMeta";
import { LinkButton, PageLayout } from "./PageSections";

const NotFound = () => {
  return (
    <PageLayout title={"Page not found"}>
      <PageMeta
        title={"Page not found"}
        noIndex
      />
      <section className={"content-box not-found"}>
        <p>The page you&apos;re looking for doesn&apos;t exist or has moved.</p>
        <LinkButton path={ROUTES.HOME}>Back to Home</LinkButton>
      </section>
    </PageLayout>
  );
};

export default NotFound;
